// @ts-nocheck
import { Helmet } from 'react-helmet-async';
import VuiBreadcrumb from '../../../../vodea/@vodea-ui/components/VuiBreadcrumb';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useMemo } from 'react';
import { useState } from '@hookstate/core/dist';
import { $clone, defaultActionFormatter } from '../../../../vodea/utilities';
import { Link, useLocation } from 'react-router-dom';
import VuiDateRangePicker from '../../../../vodea/@vodea-ui/components/Forms/VuiDateRangePicker';
import { useTranslation } from 'react-i18next';
import useIsMounted from '../../../../vodea/utilities/hooks/useIsMounted';
import SalesOrderRepository from '../../../../repositories/SalesOrderRepository';
import { AxiosError, AxiosResponse } from 'axios';
import { showToast } from '../../../../vodea/utilities/helpers/global';
import moment from 'moment';
import _ from 'lodash';
import VuiActionModal from '../../../../vodea/@vodea-ui/components/Modal/VuiActionModal';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../stores';
import VuiNumberFormat from '../../../../vodea/@vodea-ui/components/VuiNumberFormat';
import fileDownload from 'js-file-download';
import useScroll from '../../../../vodea/utilities/hooks/useScroll';
import DataTableInfiniteScroll, { ITableColumn } from '../../../../vodea/@vodea-ui/components/DataTableInfiniteScroll';
import VuiSearch from '../../../../vodea/@vodea-ui/components/VuiSearch';
import VuiSelect from '../../../../vodea/@vodea-ui/components/Forms/VuiSelect';
import { DEFAULT_PAGE_SIZE, defaultChannelOptions } from '../../../../constants';
import { VuiButton } from '../../../../vodea/@vodea-ui/components/VuiButton';
import WidgetCard from '../../../../vodea/@vodea-ui/components/WidgetCard';
import WidgetRepository from '../../../../repositories/WidgetRepository';

const SalesOrder: React.FC<any> = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isMounted = useIsMounted();

  const permissions = useSelector((state: RootState) => state.permission.permission.permissions);
  const [totalData, setTotalData] = React.useState<number>(0);
  const tableDeleteId = useState(0);
  const showActionModal = useState(false);
  const { isBottom } = useScroll();
  const [hasMore, setHasMore] = React.useState<boolean>(false);
  const [isFetchingMoreData, setIsFetchingMoreData] = React.useState<boolean>(false);
  const [hasInitialize, setHasInitialize] = React.useState<boolean>(false);
  const selectedChannel = useState(null);
  const selectedStatus = useState(null);

  const tableOnClickDelete = (id: number) => {
    tableDeleteId.set(id);
    showActionModal.set(true);
  };

  const tableHandleOnContinue = (e: React.MouseEvent) => {
    SalesOrderRepository.delete(tableDeleteId.get())
      .then((response: AxiosResponse) => {
        showToast(response.data.message, response.data.success ? 'success' : 'error');
        showActionModal.set(false);
        getTableData(true);
      })
      .catch((e: AxiosError) => {
        showToast(e.message, 'error');
      });
  };

  const title = t('Sales Order');

  const tableConfig = useState({
    search: '',
    page: 1,
    per_page: DEFAULT_PAGE_SIZE,
    sorted_by: 'desc',
    order_by: 'date',
    total: 0,
    loading: false,
    channel: null,
    status: null,
    // additional

    date_from: moment().format('YYYY-MM-DD'),
    date_to: moment().format('YYYY-MM-DD')
  });

  const tableData = useState<any[]>([]);

  const tableColumns: ITableColumn[] = [
    {
      dataField: 'number',
      text: 'Number'
    },
    {
      dataField: 'date',
      text: 'Order Date',
      render: (cell: any) => {
        return moment(cell).format('D MMMM YYYY hh:mm A');
      }
    },
    {
      dataField: 'customer_name',
      text: 'Customer'
    },
    {
      dataField: 'grand_total',
      text: 'Total',
      render: (cell: any) => {
        return <VuiNumberFormat data={cell} prefix={'IDR '} />;
      }
    },
    {
      dataField: 'payment_amount',
      text: 'Receive Payment',
      render: (cell: any) => {
        return <VuiNumberFormat data={cell} prefix={'IDR '} />;
      }
    },
    {
      dataField: 'outstanding',
      text: 'Remaining Balance',
      render: (cell: any) => {
        return <VuiNumberFormat data={cell} prefix={'IDR '} />;
      }
    },
    {
      dataField: 'outstanding',
      text: 'Status',
      render: (cell: any) => {
        return Number(cell) === 0 ? 'Paid' : 'Unpaid';
      }
    },
    {
      dataField: 'action',
      text: 'Action',
      render: defaultActionFormatter,
      formatExtraData: {
        location: location.pathname,
        actionDelete: tableOnClickDelete,
        permission: 'sales-order',
        permissions: permissions,
        isLongTable: true
      }
    }
  ];

  const changeTableLoading = (val: boolean) => {
    if (isMounted.current) {
      tableConfig.loading.set(val);
    }
  };

  const getTableData = async (reset: boolean = false, forNextPage: boolean = false) => {
    if (reset) tableConfig.page.set(1);

    if (!reset && tableConfig.page.get() + 1 > 1 && tableData.get().length < tableConfig.per_page.get()) {
      return;
    }

    if (isMounted.current && forNextPage) {
      setIsFetchingMoreData(true);
      tableConfig.page.set(tableConfig.page.get() + 1);
    } else {
      changeTableLoading(true);
    }

    if (isMounted.current) {
      setHasMore(true);
    }

    const conf = _.omit($clone(tableConfig.value), ['loading', 'total']);

    let params: any = {};
    Object.keys(conf).forEach(prop => {
      if (conf[prop]) {
        params[prop] = conf[prop];
      }
    });

    if (isMounted.current && !forNextPage) tableData.set([]);

    await SalesOrderRepository.all(params)
      .then((response: AxiosResponse) => {
        if (isMounted.current) {
          const { data: responseData } = response.data;
          tableData.merge(responseData);
          setIsFetchingMoreData(false);
          setHasInitialize(true);
          if (responseData.length < tableConfig.per_page.get()) {
            setHasMore(false);
          }
          if (reset) {
            setTotalData(response.data.total_data);
          }
        }

        changeTableLoading(false);
      })
      .catch((e: AxiosError) => {
        if (e.isAxiosError) showToast(e.message, 'error');
        if (e && e.message !== 'all canceled' && isMounted.current) {
          setHasInitialize(true);
          setIsFetchingMoreData(false);
          changeTableLoading(false);
        }
      });
  };

  useMemo(() => {
    getTableData(true);
  }, []);

  useMemo(() => {
    if (isBottom && hasInitialize && !isFetchingMoreData && hasMore) {
      getTableData(false, true);
    }
  }, [isBottom]);

  const handleTableSearch = (value: string) => {
    if (isMounted.current) {
      tableConfig.search.set(value);
      getTableData(true);
    }
  };

  const handleTableDateRange = (start: any, end: any) => {
    tableConfig.date_from.set(start.format('YYYY-MM-DD'));
    tableConfig.date_to.set(end.format('YYYY-MM-DD'));

    getTableData(true);
  };

  const loadingExport = useState(false);

  const handleExport = async () => {
    loadingExport.set(true);

    const conf = _.omit($clone(tableConfig.value), ['loading', 'total']);

    let params: any = {};
    Object.keys(conf).forEach(prop => {
      if (conf[prop]) {
        params[prop] = conf[prop];
      }
    });

    SalesOrderRepository.export(params).then((response: any) => {
      fileDownload(response.data, 'sales-order-report.xls');
      loadingExport.set(false);
    });
  };

  const breadcrumbList = [
    {
      label: t('Sales'),
      link: '/sales'
    },
    {
      label: t('Sales Order'),
      link: '/sales/sales-order'
    }
  ];

  const [totalAmount, setTotalAmount] = React.useState(0);
  const [totalRemainingBalance, setTotalRemainingBalance] = React.useState(0);
  const [totalReceivePayment, setTotalReceivePayment] = React.useState(0);
  const getCardData = () => {
    const params = {
      date_to: moment(tableConfig.date_to.get()).format('YYYY-MM-DD'),
      date_from: moment(tableConfig.date_from.get()).format('YYYY-MM-DD'),
      channel: tableConfig.channel.get() || undefined,
      search: tableConfig.search.get() || undefined
    };

    if (permissions.includes('widgettotal-sales-order')) {
      WidgetRepository.totalSalesOrder(params).then(response => {
        setTotalAmount(response.data.total_amount);
        setTotalRemainingBalance(response.data.total_remaining_balance);
        setTotalReceivePayment(response.data.total_payment);
      });
    }
  };

  useEffect(() => {
    getCardData();
  }, [tableConfig.channel.get(), tableConfig.date_from.get(), tableConfig.date_to.get(), tableConfig.search.get()]);

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <VuiBreadcrumb list={breadcrumbList} />

      <div className={'page-header-component'}>
        <h3 className={'title'}>{title}</h3>

        <div className={'btn-wrapper d-flex align-items-center'}>
          <div className={'action-wrapper'}>
            <Link to={'/sales-order-simple'} className={'action-item'}>
              <button type={'button'} className={'btn btn-primary'}>
                <FontAwesomeIcon className={'icon icon-prefix'} icon={faPlus} />
                {t('Simple Create')}
              </button>
            </Link>
            {permissions.includes('sales-order.store') ? (
              <Link to={'/sales/sales-order/create'} className={'action-item'}>
                <button type={'button'} className={'btn btn-primary'}>
                  <FontAwesomeIcon className={'icon icon-prefix'} icon={faPlus} />
                  {t('Create Sales Order')}
                </button>
              </Link>
            ) : null}
            {permissions.includes('report.sales-order') ? (
              <VuiButton forSubmit={false} label={t('Export')} loading={loadingExport.get()} onClick={handleExport} />
            ) : null}
          </div>
        </div>
      </div>

      <div className='row'>
        {permissions.includes('widgettotal-sales-order') && (
          <>
            <div className={'col-md-3 mb-3'}>
              <WidgetCard tooltip='Berdasarkan dari seluruh total yang ada di sales order' title='Total' value={totalAmount} />
            </div>

            <div className={'col-md-3 mb-3'}>
              <WidgetCard
                tooltip='Berdasarkan dari seluruh total payment yang ada di sales order'
                title='Receive Payment'
                value={totalReceivePayment}
              />
            </div>

            <div className={'col-md-3 mb-3'}>
              <WidgetCard
                tooltip='Berdasarkan dari seluruh total remaining balance yang ada di sales order'
                title='Remaining Balance'
                value={totalRemainingBalance}
              />
            </div>
          </>
        )}
      </div>

      {permissions.includes('sales-order.show') ? (
        <div className={'card-paper'}>
          <div className={'card-content'}>
            <div className={'default-filter-section'}>
              <div className={'filter-item filter-special type-search'}>
                <VuiSearch value={tableConfig.search.get()} callback={handleTableSearch} />
              </div>

              <div className={'filter-item filter-special'}>
                <VuiDateRangePicker
                  startDate={tableConfig.date_from.get()}
                  endDate={tableConfig.date_to.get()}
                  callback={handleTableDateRange}
                  useRanges={true}
                />
              </div>

              <div className='filter-item'>
                <div className='form-select-wrapper'>
                  <VuiSelect
                    placeholder={'Select Channel'}
                    clearable={true}
                    options={defaultChannelOptions}
                    defaultValue={selectedChannel.get()}
                    onChange={val => {
                      selectedChannel.set(val);
                      tableConfig.channel.set(_.get(val, 'id', null));
                      getTableData(true);
                    }}
                    isMulti={false}
                  />
                </div>
              </div>

              <div className='filter-item'>
                <div className='form-select-wrapper'>
                  <VuiSelect
                    placeholder={'Select Status'}
                    clearable={true}
                    options={[
                      {
                        id: 'PAID',
                        name: 'Paid'
                      },
                      {
                        id: 'UNPAID',
                        name: 'Unpaid'
                      }
                    ]}
                    defaultValue={selectedStatus.get()}
                    onChange={val => {
                      selectedStatus.set(val);
                      tableConfig.status.set(_.get(val, 'id', null));
                      getTableData(true);
                    }}
                    isMulti={false}
                  />
                </div>
              </div>
            </div>

            <DataTableInfiniteScroll
              columns={tableColumns}
              data={tableData.get()}
              propKey={'id'}
              isLoading={tableConfig.loading.get()}
              isFetchingMoreData={isFetchingMoreData}
              totalData={totalData}
            />
          </div>
        </div>
      ) : null}

      <VuiActionModal show={showActionModal.get()} onHide={() => showActionModal.set(false)} onContinue={tableHandleOnContinue} />
    </>
  );
};

export default SalesOrder;
